import { render, staticRenderFns } from "./VerticalBarChart.vue?vue&type=template&id=052e5361&"
import script from "./VerticalBarChart.vue?vue&type=script&lang=js&"
export * from "./VerticalBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports